import CommentRoundedIcon from '@mui/icons-material/CommentRounded';
import type { SxProps } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useComments } from 'providers/CommentsContext';

const CommentsButton = ({ styles }: { styles?: SxProps }) => {
  const { toggleComments, commentsEnabled } = useComments();

  return (
    <IconButton
      title="Comments"
      onClick={toggleComments}
      size="medium"
      sx={{ backgroundColor: commentsEnabled ? 'rgba(0, 40, 58, 0.30)' : 'transparent', ...styles }}
    >
      <CommentRoundedIcon color="primary" />
    </IconButton>
  );
};

export default CommentsButton;
